export default __webpack_public_path__ + "static/media/031-corsica.a2eee29c.svg";